import styled from "styled-components";

export const CreateCampaignContainer = styled.div`
  padding: 3% 4% 0px;
`;

export const Title = styled.h1`
  display: inline-block;
  margin-bottom: 24px;
  font-size: 1.5em;
  font-weight: bold;
  border-bottom: 4px solid #ff4081;
  padding-bottom: 4px;
`;

export const FormStep = styled.div`
  margin-bottom: 1.5rem;
`;

export const Label = styled.label`
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const Required = styled.span`
  color: #e53935;
`;

export const InputField = styled.input<{ $status?: string }>`
  width: 80%;
  padding: 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  font: inherit;
  border: 1px solid
    ${({ $status }) =>
      $status === "error"
        ? "#e53935"
        : $status === "success"
        ? "#43a047"
        : "#ccc"};
`;

export const Textarea = styled.textarea`
  width: 70%;
  padding: 8px;
  border-radius: 4px;
  font: inherit;
  border: 1px solid #ccc;
`;

export const ImageInput = styled(Textarea)``;

export const HelperText = styled.p<{ $type: "error" | "success" }>`
  font-size: 0.9rem;
  color: ${({ $type }) => ($type === "error" ? "#e53935" : "#43a047")};
  margin-top: 4px;
`;

export const DollarInputWrapper = styled.div`
  position: relative;
  width: 150px;
`;

export const DollarSymbol = styled.span`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  color: #777;
`;

export const GoalInput = styled(InputField)`
  padding-left: 24px;
  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const DatesRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`;

export const DateCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DateSeparator = styled.span`
  font-size: 1.5em;
  color: #555;
`;

export const AddLocationButton = styled.button`
  margin: 15px;
  background: none;
  border: none;
  color: #ff4081;
  cursor: pointer;
  font: inherit;
  font-size: 0.95em;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const SubmitButtonContainer = styled.div`
  text-align: right;
  margin-top: 16px;
`;

export const SubmitButton = styled.button`
  background: #ff4081;
  color: #fff;
  font-size: 1em;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
